import env from './.env';

// navigate to https://www.twilio.com/console/project/settings
// Twilio Credentials: developer@industrialsmart.com, password: Donotforget12#
export const environment = {
  production: false,
  test: true,
  protectedRoutes: true,
  version: env.package_version,
  supportedLanguages: [
  'en',
  'ne',
  'ru'
  ],
  config: {
    tenant: 'earthscout.onmicrosoft.com',
    clientId: '34a5d602-3434-4899-8669-99ae3b65ee66',
    redirectUri: 'https://test.admin.earthscout.com' + '/auth-callback',
    postLogoutRedirectUri: 'https://test.admin.earthscout.com' + '/login'
    // redirectUri: 'https://eadmin-staging.azurewebsites.net' + '/auth-callback',
    // postLogoutRedirectUri: 'https://eadmin-staging.azurewebsites.net' + '/login'
  },
  scoutLogApiUrl: 'https://efproductionscoutlogsdevelopment.azurewebsites.net/api/',
  SCOUTLOG_API_KEY: 'rWnjenR73Dcif9TRaABOYT6CueQWUqrBWvdIYvXDBmK4M///sIBysQ==',
  apiUrl: 'https://escoutt.azurewebsites.net/',
  reportsApiUrl: 'https://escoutpreports.azurewebsites.net/',
  mobile: false,
  SENDGRID_API_KEY: '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'
};
